function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: a , size: c = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = s(), l = a !== null && a !== void 0 ? a : e ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ r("path", {
            fill: l,
            d: "M21.837 6.004c0-1.67-1.408-3.025-3.137-3.025H5.288c-1.728 0-3.137 1.356-3.137 3.025v8.958c0 1.345.846 2.487 2.098 2.88v1.862c0 .715.639 1.32 1.395 1.32.474 0 .866-.194 1.157-.575l1.992-2.462H18.7c1.729 0 3.137-1.358 3.137-3.025V6.004zm-.82 0v8.958c0 1.23-1.04 2.23-2.32 2.232H8.589a.418.418 0 00-.325.152l-2.117 2.622c-.205.263-.407.263-.505.263-.296 0-.574-.258-.574-.527v-2.168a.4.4 0 00-.328-.39c-1.042-.207-1.77-1.106-1.77-2.184V6.004c0-1.23 1.042-2.233 2.32-2.233H18.7c1.278 0 2.317 1.003 2.317 2.233zm-6.241 3.364c-.171.7-.51 1.434-1.011 2.185a9.02 9.02 0 01-1.27 1.54l-.027.029-.003.005a2.613 2.613 0 01-.303.263.525.525 0 01-.207.082l-.033-.006h-.009a.506.506 0 01-.174-.078 2.763 2.763 0 01-.322-.283 9.127 9.127 0 01-1.283-1.555c-.495-.748-.837-1.482-1.008-2.182-.076-.32-.151-.905.227-1.218.165-.14.414-.224.678-.238l.078-.003c.297 0 .608.084.902.24.149.082.3.166.482.27.14.078.3.117.462.117a.985.985 0 00.474-.126c.165-.095.319-.182.467-.26.292-.157.605-.241.902-.241l.076.003c.269.014.512.1.68.238.376.313.3.899.222 1.218zm.314-1.82c-.306-.253-.723-.404-1.171-.426-.042-.003-.082-.003-.115-.003a2.74 2.74 0 00-1.3.342c-.157.084-.316.173-.49.271a.138.138 0 01-.056.014.13.13 0 01-.059-.014l-.116-.065c-.13-.074-.252-.144-.371-.206a2.731 2.731 0 00-1.3-.342c-.04 0-.081 0-.12.003-.451.02-.866.173-1.171.425-.524.435-.7 1.149-.488 2.003.194.79.569 1.608 1.115 2.429a9.739 9.739 0 001.384 1.678c.059.059.26.257.431.375.149.1.317.177.482.21.048.008.098.017.151.02h.003c.017.002.028.002.045.002h.017c.017 0 .03 0 .045-.002h.005a.857.857 0 00.151-.02 1.28 1.28 0 00.48-.21 3.49 3.49 0 00.445-.39 9.622 9.622 0 001.372-1.663c.547-.824.925-1.642 1.118-2.429.21-.854.04-1.566-.487-2.003z"
        })
    }));
}, m = i;
export { m as default };
